// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalState, GlobalEvent } from './GlobalContext';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import MsgDialog from './MsgDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useForm, Controller } from "react-hook-form";

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function SearchDomainUserDialog(props) {

  const { open, onClose, sysID, onSelect } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }


  useEffect(async () => {
    // console.log("useEffect SearchDomainUserDialog[open]");

    if (open) {
      setSelectedRec(null);
    }
  }, [open]);

  const handleCloseClick = () => {
    onClose && onClose();
  }

  // const [searchText, setSearchText] = useState("");

  const [gridData, setGridData] = useState([]);

  // const handleSearchClick = () => {
  //   console.log("handleSearchClick", searchText);
  // }

  // const handleSearchTxtChange = (event) => {
  //   setSearchText(event.target.value);
  // }

  const onSubmit = async (data) => {
    // console.log(data);

    const { searchText } = data;

    setShowLoading(true);

    try {
      const vRst = await DmsService.searchDomainUsersPromise(gState.sessionID, sysID, searchText);
      // console.log("vRst", vRst);

      setShowLoading(false);

      setGridData(vRst);

    } catch (e) {
      setShowLoading(false);

      onCatchPromiseError(e);
    }

  }


  const [selectedRec, setSelectedRec] = useState(null);
  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });

    if (selRecs.length > 0) {
      setSelectedRec(selRecs[0])
    } else {
      setSelectedRec(null)
    }

  }

  const handleSelectClick = () => {
    onSelect && onSelect(selectedRec);
  }

  // React Hook the form
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      searchText: "",
    },
  });

  const watchSearchText = watch("searchText");

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorLoginID = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.LoginID, nodeB.data.LoginID)
  }

  const comparatorFullname = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Fullname, nodeB.data.Fullname)
  }

  const comparatorChinese = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.ChineseName, nodeB.data.ChineseName)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Department, nodeB.data.Department)
  }


  const columnDefs = useMemo(() => [

    { field: 'LoginID', headerName: "UserID", cellStyle: cellStyle, width: 100, comparator: comparatorLoginID, },
    { field: 'Fullname', headerName: "Fullname", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorFullname, },
    { field: 'ChineseName', headerName: "Chinese", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorChinese, },
    { field: 'Domain', headerName: "Domain", cellStyle: cellStyle, width: 100, },
    { field: 'EmailAddress', headerName: "Email", cellStyle: cellStyle, minWidth: 150, flex: "1", },
    { field: 'Department', headerName: "Department", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorDept, },
  ], []);

  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      fullWidth={true}
      maxWidth={"md"}
      aria-describedby="folderLink-dialog-description"
    >
      <DialogTitle id="folderLink-dialog-title">
        Search Domain User
      </DialogTitle>
      <DialogContent>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />

        <Box component="form" sx={{ display: 'flex', alignItems: 'center', }} onSubmit={handleSubmit(onSubmit)} >

          <Controller
            name="searchText"
            control={control}
            render={({ field }) =>
              <TextField
                {...field}
                autoFocus
                InputLabelProps={{ shrink: true, }}
                fullWidth
                label="Search Text"
                size="small"
                type="search"
                // variant="standard"
                sx={{ my: 1 }}
              />

            }
          />

          <Button type="submit" disabled={watchSearchText.trim() == ''} >
            Search
          </Button>
        </Box>




        <div className="ag-theme-material" style={{ width: '100%', height: '50vh', }}>
          <AgGridReact

            rowData={gridData}

            defaultColDef={{
              width: 100,
              resizable: true,
              sortable: true,
              suppressMovable: true,
            }}
            columnDefs={columnDefs}
            headerHeight={40}

            suppressNoRowsOverlay

            rowSelection="single"
            onSelectionChanged={onSelectionChanged}

          />
        </div>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
        <Button variant="contained" onClick={handleSelectClick} disabled={!selectedRec}  >
          Select
        </Button>
      </DialogActions>
    </Dialog>

  );
}

SearchDomainUserDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  onSelect: PropTypes.func,
};
